import { createFileRoute, Navigate } from '@tanstack/react-router';
import { getDefaultView } from '@/utils/viewHelpers';
import { DocumentHead } from '@/components/core/DocumentHead';

export const Route = createFileRoute(
  '/$tenantId/_layout/administrators/$administratorId/',
)({
  component: AdministratorRedirect,
});

function AdministratorRedirect() {
  const { tenantId, administratorId } = Route.useParams();
  const view = getDefaultView('administrator');

  return (
    <>
      <DocumentHead
        titleKey="page.administrator.details.title"
        descriptionKey="page.administrator.details.description"
        resetOnUnmount={false}
      />
      <Navigate
        to="/$tenantId/administrators/$administratorId/$view"
        params={{ tenantId, administratorId, view }}
        replace
      />
    </>
  );
}
